import {printoutPalette} from "../../core/printoutPalette";
import {printoutTheme} from "../../core/printoutTheme";
import {DEFAULT_TABLE_BORDER_COLOR, MIN_COLUMN_WIDTH_PX} from "./printoutTableOptions";

const CELL_PADDING = `${printoutTheme.table.rowPaddingY}px 12px`;
export const tableBlockSx = {
    '& .printout-table-block-wrapper': {
        boxSizing: 'border-box',
        maxWidth: '100%',
        overflow: 'visible',
        position: 'relative',
        width: '100%',
    },
    '& .printout-table-block': {
        borderCollapse: 'separate',
        borderSpacing: 0,
        boxSizing: 'border-box',
        maxWidth: '100%',
        tableLayout: 'fixed',
        width: '100%',
        breakInside: 'auto',
    },
    // Keep rows intact and repeat header rows across printed pages.
    '& .printout-table-block tr': {
        breakAfter: 'auto',
        breakInside: 'avoid',
    },
    '@media print': {
        '& .printout-table-block tr:has(> th)': {
            display: 'table-header-group',
        },
    },
    '& .printout-table-block tr > th, & .printout-table-block tr > td': {
        backgroundColor: 'var(--printout-table-background-color, transparent)',
        borderTopColor: `var(--printout-table-border-top-color, ${DEFAULT_TABLE_BORDER_COLOR})`,
        borderRightColor: `var(--printout-table-border-right-color, ${DEFAULT_TABLE_BORDER_COLOR})`,
        borderBottomColor: `var(--printout-table-border-bottom-color, ${DEFAULT_TABLE_BORDER_COLOR})`,
        borderLeftColor: `var(--printout-table-border-left-color, ${DEFAULT_TABLE_BORDER_COLOR})`,
        color: printoutPalette.secondaryText,
        borderStyle: 'solid',
        borderWidth: '1px 0 0 1px',
        boxSizing: 'border-box',
        lineHeight: printoutTheme.type.body1.lineHeight,
        minWidth: `${MIN_COLUMN_WIDTH_PX}px`,
        p: CELL_PADDING,
        position: 'relative',
        printColorAdjust: 'exact',
        verticalAlign: 'top',
        WebkitPrintColorAdjust: 'exact',
    },
    '& .printout-table-block tr > th': {
        breakAfter: 'avoid',
        fontWeight: 'inherit',
        textAlign: 'inherit',
    },
    '& .printout-table-block tr > th:last-child, & .printout-table-block tr > td:last-child': {
        borderRightWidth: 1,
    },
    '& .printout-table-block tr:last-child > th, & .printout-table-block tr:last-child > td': {
        borderBottomWidth: 1,
    },
    '& .printout-table-block th p, & .printout-table-block td p': {
        my: 0,
    },
    '& .printout-table-block th h1, & .printout-table-block td h1': {
        lineHeight: 1.05,
        m: '0 0 4px',
    },
    '& .printout-table-block th h2, & .printout-table-block td h2, & .printout-table-block th h3, & .printout-table-block td h3, & .printout-table-block th h4, & .printout-table-block td h4': {
        m: '0 0 4px',
    },
    '& .printout-table-block-resize-handle': {
        bottom: 0,
        cursor: 'col-resize',
        position: 'absolute',
        top: 0,
        transform: 'translateX(-50%)',
        width: '11px',
        zIndex: 2,
        '&::after': {
            backgroundColor: 'transparent',
            bottom: 0,
            content: '""',
            left: '50%',
            position: 'absolute',
            top: 0,
            transform: 'translateX(-50%)',
            transition: 'background-color 120ms ease',
            width: '2px',
        },
        '&:hover::after, &:active::after': {
            backgroundColor: 'primary.main',
        },
    },
};
